"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METRIC_TYPES = void 0;
exports.METRIC_TYPES = ["NPS", "prop8+", "mean", "mode", "frequency", "Custom proportion"];
